@if (!showYearMonthDay) {
  <div [title]="toolTip">
    @if (prefixCode) {
      <span class="prefix-code">{{ prefixCode }}{{ prefixSeparator }}</span>
    }
    <span class="datetime-text">
      {{ startDate | date: "h:mm a" }}<span class="sep">{{ dateTimeSeparator }}</span
      >{{ endDate | date: "h:mm a" }}
    </span>
  </div>
}

@if (showYearMonthDay) {
  <div [title]="toolTip">
    @if (prefixCode) {
      <span class="prefix-code">{{ prefixCode }}{{ prefixSeparator }}</span>
    }
    <span class="datetime-text">
      {{ startDate | date: "M/dd/yy h:mm a" }}<span class="sep">{{ dateTimeSeparator }}</span
      >{{ endDate | date: "M/dd/yy h:mm a" }}
    </span>
  </div>
}
